import React from 'react';
import { Sidebar, useUserinfo } from '@mss/mss-component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSlidersH,
  faProjectDiagram,
  faUserFriends,
} from '@fortawesome/free-solid-svg-icons';

import { useTranslation } from 'react-i18next';
import { HardDrive } from 'react-feather';

export default function EditSidebar() {
  const [t] = useTranslation(['authorization', 'asset', 'common']);
  const [hasPermission] = useUserinfo();
  return (
    <Sidebar>
      {hasPermission(['change_user', 'view_user']) && (
        <Sidebar.Item
          title={t('User settings')}
          data-ta="UserSettingsSidebar"
          icon={<FontAwesomeIcon icon={faSlidersH} size={'sm'} />}
          url="settings"
        />
      )}
      {hasPermission(['add_usergroup', 'view_group']) && (
        <Sidebar.Item
          title={t('Groups')}
          data-ta="GroupsSidebar"
          icon={<FontAwesomeIcon icon={faUserFriends} size={'sm'} />}
          url="groups"
        />
      )}
      {hasPermission(['change_userpermission', 'view_userpermission']) && (
        <Sidebar.Item
          title={t('Permission')}
          data-ta="PermissionSidebar"
          icon={<FontAwesomeIcon icon={faProjectDiagram} size={'sm'} />}
          url="permissions"
        />
      )}
      {hasPermission([
        'view_userobjectpermission',
        'change_userobjectpermission',
      ]) && (
        <Sidebar.Item
          title={t('Object permissions')}
          data-ta="ObjectPermissionsSidebar"
          icon={<HardDrive size={14} />}
          url="objectpermissions"
        />
      )}
    </Sidebar>
  );
}
